module.exports = __webpack_public_path__ + "img/line.2a5d6308.svg";